import React from 'react';
import { PageSessionThreePlanoAnualProps } from './SessionAnaliseMunicipios';
import StyledGlobal from '../../../../PlanoAnual2025.styled';
import PageTemplatePlanoAnual from '../../templates/PageTemplatePlanoAnual';
import GridColumns from 'pages/ebooks/components/templates/GridColumns';
import { fetchStorageFile } from 'hooks/StoreFiles';
import styled from 'styled-components';
import Colors from 'enums/Colors';
import { ConfigProvider, Image, Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { RiDoubleQuotesL } from 'react-icons/ri';
import Quote from 'pages/ebooks/components/Quote';
import CardQRcodeVideosPlanoAnual from '../../components/CardQRcodeVideosPlanoAnual';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';

interface DataType {
    key: string;
    name: string;
    solucoes: string;
    // estudantes: string;
}

const dataSource: DataType[] = [
    {
        key: '1',
        name: 'Gestão Nota 10',
        solucoes: `
        O programa é voltado para o fortalecimento das lideranças educacionais e escolares,
        apoiando a atuação de diretores tecnicamente qualificados e preparados para garantir o
        alcance das metas de aprendizagem e a melhoria dos indicadores educacionais. 
        `,
        // estudantes: '44.000',
    },
    {
        key: '2',
        name: 'Circuito 360',
        solucoes: `
        O Programa tem como objetivo apoiar as secretarias de educação na
        formulação e gestão de políticas educacionais para os <strong>Anos Iniciais do
        Ensino Fundamental</strong>, com foco na perspectiva de educação integral. 
        `,
        // estudantes: '23.000',
    },
    {
        key: '3',
        name: 'Se Liga',
        solucoes: `
            O programa é voltado para a alfabetização de estudantes com distorção
            idade-série matriculados do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
        // estudantes: '55',
    },
    {
        key: '4',
        name: 'Acelera Brasil',
        solucoes: `
            O programa tem como objetivo reduzir a distorção idade-série por meio da
            aceleração do fluxo escolar de estudantes do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
        // estudantes: '54',
    },
    {
        key: '5',
        name: 'Fórmula da Vitória',
        solucoes: `
        O programa tem como objetivo qualificar a aprendizagem em Língua Portuguesa
        de estudantes dos <strong>Anos Finais do Ensino Fundamental</strong>, contribuindo para
        reverter quadros de reprovação e exclusão no ambiente escolar.
        `,
        // estudantes: '241',
    },
];

const columns: ColumnsType<DataType> = [
    {
        title: 'SOLUÇÃO EDUCACIONAL',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
        title: 'DESCRIÇÃO',
        dataIndex: 'solucoes',
        key: 'solucoes',
        align: 'center',
        render: (text: string) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: Colors.White,
                    padding: '20px',
                    borderRadius: 8,
                }}
            >
                <span style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        ),
    },
    // {
    //     title: 'CRIANÇAS E JOVENS ATENDIDOS',
    //     dataIndex: 'estudantes',
    //     key: 'estudantes',
    //     align: 'center',
    //     render: (text: string) => (
    //         <div
    //             style={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 justifyContent: 'center',
    //                 backgroundColor: Colors.Yellow,
    //                 borderRadius: 8,
    //             }}
    //         >
    //             <span
    //                 style={{
    //                     fontWeight: 'bold',
    //                     color: Colors.White,
    //                     fontSize: '22px',
    //                     alignSelf: 'center',
    //                     justifySelf: 'center',
    //                 }}
    //             >
    //                 {text}
    //             </span>
    //         </div>
    //     ),
    // },
];

const Styled = {
    CardWhite: styled.div`
        background-color: white;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
    CardWhite2: styled.div`
        background-color: #f7f4f3;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
    `,

    CardYellow: styled.div`
        background-color: #f1bc40;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        padding: 20px;
        font-size: 18px;
        line-height: 24px;
        width: 100%;
        color: ${Colors.White};
    `,
    TableWrapper: styled.div`
        width: 100%;
        overflow-x: auto;
    `,
};

const PageThreeOnePlanoAnual: React.FC<PageSessionThreePlanoAnualProps> = () => {
    const isMaxWidth800 = IsCustomMaxWidth(800);

    return (
        <>
            <PageTemplatePlanoAnual numberPage={12} stylesContent={{ marginRight: isMaxWidth800 ? '0' : '80px' }}>
                <StyledGlobal.Title blue>3.1 JABOATÃO DOS GUARARAPES</StyledGlobal.Title>

                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ marginLeft: 0 }}
                >
                    <StyledGlobal.ContentColumn style={{ marginRight: isMaxWidth800 ? '0' : '80px' }}>
                        <p>
                            Situado na Região Metropolitana de Recife, Jaboatão dos Guararapes é o segundo município mais populoso de Pernambuco,
                            com mais de 680 mil habitantes. A sua proximidade com a capital impulsionou a sua urbanização e industrialização, mas
                            não mitigou os profundos desafios sociais e educacionais. <br /> <br />
                            Apesar de seu PIB elevado, a distribuição desigual da riqueza no município é um problema refletido em indicadores
                            educacionais que demandam atenção. Para transformar essa realidade, em 2025, a cidade firmou parceria com o Instituto
                            Ayrton Senna com o objetivo de implementar soluções eficazes e acelerar a qualidade da educação.
                        </p>

                        <Image
                            width={'100%'}
                            src={fetchStorageFile('anexo_storage_files_8015342376765729154.webp_2025-11-19-1763572088641.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <h2>3.1.1 A EDUCAÇÃO NO MUNICÍPIO</h2>

                        <p style={{ marginTop: '20px' }}>
                            Jaboatão dos Guararapes registrou avanços relevantes na educação nos últimos anos, sobretudo na trajetória dos
                            estudantes, com taxas de insucesso bem abaixo da média nacional e reflexos na redução da distorção idade-série. Ainda
                            assim, os desafios de aprendizagem permanecem expressivos, tanto na alfabetização quanto ao longo do Ensino
                            Fundamental.
                        </p>

                        <StyledGlobal.TitleYellow>Acesso</StyledGlobal.TitleYellow>

                        <div
                            style={{
                                backgroundColor: '#f7f4f3',
                                width: 'fit-content',
                                borderRadius: '20px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: '20px',
                            }}
                        >
                            <Image
                                src={fetchStorageFile('anexo_storage_files_16508879131916560139.png_2025-11-19-1763572538646.png')}
                                alt={`
                                    Dois blocos comparativos intitulados ‘Anos Iniciais’ e ‘Anos Finais’. 
                                    Cada bloco apresenta três ícones: escola, professor e cadeira escolar. Nos anos iniciais: 96 escolas, 1.151 professores e 26.368 matrículas. Nos anos finais: 57 escolas, 995 professores e 22.765 matrículas.” 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                            <p>Fonte: MEC/Inep - Censo Escolar (2024). Rede Municipal.</p>
                        </div>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={13} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr 1fr',
                        tablet: '1fr 1fr',
                        mobile: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>ALFABETIZAÇÃO</StyledGlobal.TitleYellow>
                        <p>
                            Em sentido oposto ao observado no país e no estado de Pernambuco, onde houve avanço na alfabetização entre 2023 e
                            2024,{' '}
                            <strong>Jaboatão dos Guararapes apresentou queda no percentual de estudantes alfabetizados na idade certa.</strong>
                        </p>
                        <Styled.CardWhite2>
                            <Image
                                width={'280px'}
                                src={fetchStorageFile('anexo_storage_files_9194151265558467874.png_2025-11-19-1763573688069.png')}
                                alt={`Gráfico com duas barras comparando a taxa de alfabetização em Jaboatão dos Guararapes: barra azul escura de 2023 com 57,3% e barra azul clara de 2024 com 55%. Uma seta indica a redução. `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>DISTORÇÃO IDADE-SÉRIE</StyledGlobal.TitleYellow>
                        <p>
                            No intervalo de 10 anos, as taxas de distorção idade-série no município caíram 12,8 p.p. e 16,4 p.p. nos anos
                            iniciais e finais do Ensino Fundamental, respectivamente;{' '}
                            <strong> quedas mais acentuadas do que as observadas na média do país.</strong>
                        </p>
                        <Styled.CardWhite2>
                            <Image
                                width={'280px'}
                                src={fetchStorageFile('anexo_storage_files_3206722767593395616.png_2025-11-19-1763574485287.png')}
                                alt={`Gráfico de barras comparando a distorção idade-série no município de Jaboatão dos Guararapes em 2014 e 2024. 
                                    Nos anos iniciais, queda de 24,4% para 11,8%. Nos anos finais, queda de 35,7% para 18,3%. Setas destacam redução das taxas.” `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>
                            APROVAÇÃO, <br /> REPROVAÇÃO E ABANDONO
                        </StyledGlobal.TitleYellow>
                        <p>
                            As taxas de aprovação nos anos iniciais e finais do Ensino Fundamental são bem altas e{' '}
                            <strong>superiores às médias estadual e nacional.</strong> Em 10 anos a taxa de insucesso escolar (reprovação +
                            abandono) nos anos finais no município caiu mais de 12 pontos percentuais.
                        </p>
                        <Styled.CardWhite2>
                            <Image
                                width={'280px'}
                                src={fetchStorageFile('anexo_storage_files_1978183882282143442.png_2025-11-19-1763574687587.png')}
                                alt={`
                                    Gráfico de barras empilhadas mostrando taxas de aprovação, reprovação e abandono em 2024, comparando Jaboatão dos Guararapes, Pernambuco e Brasil. Nos anos iniciais, aprovação: Jaboatão dos Guararapes 99%, Pernambuco 97,5%, Brasil 96,9%. 
                                    Reprovação: Jaboatão dos Guararapes 0,9%, Pernambuco 2,4%, Brasil 2,8%. 
                                    Abandono: Jaboatão dos Guararapes 0,1%, Pernambuco 0,1%, Brasil 0,3%. 
                                    Nos anos finais, aprovação: Jaboatão dos Guararapes 97%, Pernambuco 94%, Brasil 92%.  
                                    Reprovação: Jaboatão dos Guararapes 2,8%, Pernambuco 5,3%, Brasil 6,6%. 
                                    Abandono: Jaboatão dos Guararapes 0,2%, Pernambuco 0,7%, Brasil 1,4%.
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>APRENDIZADO ADEQUADO</StyledGlobal.TitleYellow>
                        <p>
                            Em 2023,{' '}
                            <strong>
                                somente 45,8% dos(as) estudantes do 5º ano do Ensino Fundamental possuíam aprendizado adequado em Língua
                                Portuguesa,
                            </strong>{' '}
                            valor próximo à média do estado, mas significativamente inferior ao observado na média nacional.{' '}
                            <strong>No 9º ano, esse percentual era ainda mais baixo, 30,5% no município.</strong>
                        </p>
                        <Styled.CardWhite2>
                            <Image
                                width={'280px'}
                                style={{ objectFit: 'cover' }}
                                src={fetchStorageFile('anexo_storage_files_3928801776180976605.png_2025-11-19-1763575030057.png')}
                                alt={`
                                   Conjuntos de ícones de crianças representando proporção de aprendizado adequado em Língua Portuguesa. No 5º ano, a pintura dos ícones em azul indica 45,8%. No 9º ano, a pintura dos ícones em azul indica 30,5%. 1  
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fontes: MEC - Indicador Criança Alfabetizada. MEC/Inep - Censo Escolar. MEC/Inep - SAEB.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={14} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '480px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.Title style={{ color: Colors.Blue }}>
                            3.1.2 APRESENTAÇÃO DO PLANO ANUAL EM JABOATÃO DOS GUARARAPES
                        </StyledGlobal.Title>
                        <p>
                            No âmbito do Plano Anual Instituto Ayrton Senna, o município de Jaboatão dos Guararapes implementou cinco soluções
                            educacionais, para ajudar a rede de ensino a lidar com os desafios de alfabetização, atraso escolar, defasagem de
                            aprendizagens e gestão escolar.
                        </p>

                        <StyledGlobal.CardBlue
                            style={{ maxWidth: '240px', marginTop: '80px', padding: '40px' }}
                            role="img"
                            aria-label="Retângulo azul contendo o texto: mais de 46 mil professores e alunos da rede pública de ensino"
                        >
                            <div className="metrica">
                                <span> +46 mil </span> <p>professores e alunos da rede pública de ensino</p>
                            </div>
                        </StyledGlobal.CardBlue>
                    </StyledGlobal.ContentColumn>
                    <Styled.TableWrapper>
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorTextHeading: '#0e60e8',
                                    colorBgBase: '#eae8e6',
                                },
                            }}
                            table={{
                                style: {
                                    background: 'none',
                                },
                            }}
                        >
                            <Table pagination={false} dataSource={dataSource} columns={columns} scroll={{ x: 900 }} style={{ minWidth: 900 }} />
                        </ConfigProvider>
                    </Styled.TableWrapper>
                </ResponsiveGrid>

                <p style={{ fontSize: '14px' }}>
                    Fontes: MEC/Inep - Censo Escolar (2024). Rede Municipal. Sistema de Monitoramento Instituto Ayrton Senna.
                </p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={15} stylesContent={{ marginRight: isMaxWidth800 ? '20px' : '80px' }}>
                <StyledGlobal.Title style={{ color: Colors.Blue, fontSize: '26px' }}>3.1.3 RESULTADOS</StyledGlobal.Title>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr 1fr',
                        tablet: '1fr 1fr',
                        mobile: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Diante dos desafios educacionais de Jaboatão dos Guararapes,{' '}
                            <strong>a parceria com o Instituto Ayrton Senna tem se afirmado como uma aposta estratégica </strong> da gestão
                            municipal, que vê nos programas do Instituto caminhos concretos para enfrentar lacunas de aprendizagem e superar os
                            principais entraves da rede.{' '}
                            <strong>
                                Os resultados em termos de alfabetização, aumento da proficiência em Língua Portuguesa e das práticas de leitura
                                já são visíveis
                            </strong>
                            , contribuindo para um futuro melhor para os estudantes.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Em 2025, no escopo dessa parceria, foram realizados{' '}
                            <strong>
                                16 cursos presenciais com técnicos da secretaria de educação, diretores, coordenadores pedagógicos e professores
                            </strong>
                            , a fim de preparar os diferentes atores para implementar os programas educacionais no município: Gestão Nota 10,
                            Fórmula da Vitória, Circuito 360, Se Liga e Acelera Brasil. Além disso, foram{' '}
                            <strong>realizados 28 cursos virtuais</strong>, para que os educadores tivessem acesso contínuo às formações.
                        </p>
                        <p>
                            Os participantes avaliaram as <br /> formações de forma muito positiva, <br />
                            <strong style={{ fontSize: '24px' }}>alcançando um nível de satisfação médio de 81%.</strong>
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Além das formações sobre os programas educacionais, os profissionais de educação contaram com apoio contínuo da
                            equipe do Instituto Ayrton Senna ao longo do ano.
                        </p>
                        <StyledGlobal.CardGray
                            style={{ maxWidth: '250px' }}
                            role="img"
                            aria-label="Foram realizadas 9 oficinas presenciais e 11 oficinas virtuais"
                        >
                            <span> Foram realizadas</span> <strong>9 oficinas presenciais e 11 oficinas virtuais</strong>
                        </StyledGlobal.CardGray>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardYellow>
                            <RiDoubleQuotesL size={28} />

                            <p
                                dangerouslySetInnerHTML={{
                                    __html: `
                                                 A formação trata de temáticas muito pertinentes e emergenciais, instrumentalizando os gestores e equipe quanto à
                            gestão de resultados e planejamento de estratégias para a superação das dificuldades apuradas. Penso que o material
                            apresentado (e que passará a compor a rotina escolar) é de excelência técnica e metodológica e, com certeza, será um
                            elemento crucial para a melhoria da qualidade dos serviços pedagógicos e educacionais ofertados à população
                            jaboatonense! Excelente iniciativa! Parabéns!"
                                <br />
                                <br />
                            <span style="font-weight: 300; font-size: 16px;">
                            Depoimento de um dos
                            participantes da formação
                            do Gestão Nota 10
                            </span>
                                `,
                                }}
                            />
                        </Styled.CardYellow>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>

                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>

            <PageTemplatePlanoAnual numberPage={16} stylesContent={{ marginRight: isMaxWidth800 ? '20px' : '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            O acompanhamento dos resultados educacionais em Jaboatão ganhou força com a{' '}
                            <strong>institucionalização do Comitê Gestor,</strong> que organiza a governança e torna a análise de dados viva,
                            envolvendo todos os atores na
                            <strong> apropriação, responsabilização e busca por soluções para os desafios evidenciados.</strong> O Comitê é
                            formado pelo Secretário de Educação, por profissionais da Secretaria responsáveis pelos programas educacionais, e por
                            especialistas do Instituto Ayrton Senna.
                            <br />
                            <br />
                            Para que a análise de dados realmente informe as decisões da educação municipal, é importante contar com informações
                            que mostrem o que acontece no dia a dia da sala de aula. Por isso, cada programa desenvolvido no município indicou
                            com clareza quais dados deveriam ser coletados e acompanhados pelos diferentes envolvidos na política educacional.
                            Além disso, foi disponibilizada uma plataforma de monitoramento para reunir e organizar essas informações,
                            facilitando decisões rápidas e voltadas ao desenvolvimento integral dos estudantes.
                            <br />
                            <br />O perfil dos estudantes atendidos, variou de acordo com o programa implementado, como mostram os gráficos ao
                            lado.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite2 style={{ padding: '20px' }}>
                            <h2 style={{ fontSize: '18px' }}>FAIXA ETÁRIA</h2>
                            <ResponsiveGrid
                                templates={{
                                    desktop: '1fr 1fr',
                                    notebook: '1fr 1fr',
                                    tablet: '1fr',
                                }}
                                styles={{ margin: 0, gap: '40px' }}
                            >
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_15013159036901922895.png_2025-11-19-1763582614961.png')}
                                    alt={`Gráfico de pizza mostrando idades dos estudantes do Acelera Brasil: 10 anos (5,6%), 11 anos (25,9%),12 anos (53,7%), 13 anos (13%), e 14 anos (1,9%). Cada fatia identifica a porcentagem por faixa etária.`}
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_174014476548331749.png_2025-11-19-1763582629826.png')}
                                    alt={`Gráfico de pizza apresentando idades dos estudantes do Se Liga: 10 anos (40%), 11 anos (32,7%), 12 anos (23,6%) e 13 anos (3,6%). Cada fatia identifica a porcentagem por faixa etária.`}
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </ResponsiveGrid>
                            <p>
                                As turmas do Acelera Brasil no município foram compostas por uma maioria (54%) de estudantes com 12 anos de idade
                                (que deveriam estar cursando o sétimo ano, seguindo o fluxo esperado da educação básica).
                                <br />
                                <br />
                                Já os estudantes das turmas do Se Liga eram relativamente mais jovens (mas ainda assim com algum nível de
                                distorção idade-série), sendo 73% de alunos(as) com idade entre 10 e 11 anos
                            </p>
                        </Styled.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={17} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            A participação nos programas já trouxe resultados expressivos do ponto de vista de aprendizado desses(as) estudantes.
                            <strong>
                                No início do ano, todos(as) os(as) 55 alunos(as) das turmas do Se Liga estavam no nível mais baixo de Língua
                                Portuguesa
                            </strong>
                            , com desempenho equivalente ao esperado para a Educação Infantil. Já no mês de setembro, esse nível foi observado em
                            apenas 2% dos(as) estudantes; e mais da metade,{' '}
                            <strong>59%, atingiram o nível 3, compatível com o 2º ano do Ensino Fundamental</strong> e caracterizado, por
                            exemplo, por habilidades como leitura global, por memorização, de textos de tradição oral, poemas, entre outros, e
                            escrita de textos de diferentes gêneros do campo da vida cotidiana.
                            <br />
                            <br />
                            No mesmo período,{' '}
                            <strong>
                                o percentual de estudantes das turmas do Acelera Brasil que liam com fluência passou de apenas 14% para 92%.
                            </strong>{' '}
                            Já em relação à escrita, o percentual de estudantes que escrevia palavras com sílabas complexas ortograficamente
                            passou de 26% para 82%. Por fim, no que se refere à produção de textos, no início do programa nenhum(a) dos(as) 54
                            estudantes conseguia escrever textos com frases ampliadas, com desenvolvimento lógico de ideias interligadas por
                            conectivos, competência que foi adquirida por 55% dos(as) alunos(as) ao final de setembro.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite2 style={{ padding: '20px', gap: '40px' }}>
                            <h2 style={{ fontSize: '18px' }}>NÍVEL EM LÍNGUA PORTUGUESA</h2>
                            <ResponsiveGrid
                                templates={{
                                    desktop: '1fr 1fr',
                                    tablet: '1fr',
                                }}
                                styles={{ margin: 0, gap: '20px' }}
                            >
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_9791436716942016760.png_2025-11-19-1763583027927.png')}
                                    alt={`
                                        Dois grupos de ícones em formato de círculo, com preenchimento em amarelo representando o percentual de estudantes no nível mais baixo em língua portuguesa.
                                        Texto que acompanha o primeiro grupo diz: 'No início do ano, todos os estudantes do Se Liga estavam no nível mais baixo de Língua Portuguesa'
                                        Texto que acompanha o segundo grupo diz: 'Em setembro, 59% atingiram o nível 3, compatível com o 2º ano do Ensino Fundamental'
                                        `}
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_5992854314235654004.png_2025-11-19-1763583162488.png')}
                                    alt={`
                                        Dois grupos de ícones em formato de círculo, com preenchimento em azul representando o percentual de estudantes com fluência leitora.  
                                        Texto que acompanha o primeiro grupo diz: 'No mesmo período, o percentual de estudantes do Acelera Brasil que liam com fluência era de apenas 14%.'
                                        Texto que acompanha o segundo grupo diz: 'Esse percentual saltou para 92% de estudantes lendo com fluência'
                                        `}
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </ResponsiveGrid>
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>

                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={18} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Esses resultados ilustram a{' '}
                            <strong>efetividade dos programas em promover a alfabetização e o ganho de aprendizagem</strong>, criando condições
                            para que estudantes com maiores desafios educacionais avancem em sua trajetória escolar com mais segurança e
                            autonomia, <strong>ampliando as chances de concluir a educação básica e vivenciar plenamente sua cidadania.</strong>
                            <br />
                            <br />O sucesso dos programas evidenciado anteriormente, foi potencializado pela{' '}
                            <strong>distribuição de livros para os estudantes.</strong> Em 2025, foram mais de 7 mil livros distribuídos, sendo{' '}
                            <strong>2.346 livros pedagógicos e 5.170 livros de literatura infanto-juvenil</strong>, incluindo exemplares com
                            conteúdo adaptado, garantindo acessibilidade física, visual e cognitiva.
                        </p>
                        <Styled.CardWhite2 style={{}}>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_5513046979209512546.png_2025-11-19-1763583593032.png')}
                                alt={`Quadro com quatro ícones de livros representando o número de exemplares distribuídos por programa e o número de exemplares de livros de literatura. 
                                    Se Liga: 340 livros; Acelera Brasil: 588 livros; Fórmula da Vitória: 1.418 livros; Livros de Literatura: 5.170 livros`}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Styled.CardWhite2 style={{ padding: '20px', gap: '40px' }}>
                            <h2 style={{ fontSize: '18px' }}>EXEMPLOS DOS LIVROS DE LITERATURA DISTRIBUÍDOS</h2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_8029060061994962561.png_2025-11-19-1763583702142.png')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={19} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Um desdobramento concreto e mensurado pelas estratégias de monitoramento é{' '}
                                    <strong>o aumento considerável da prática leitora </strong> pelos(as) estudantes atendidos pelos programas.
                                    <br /> <br />
                                    No Acelera Brasil, a média de livros lidos por estudante passou de 0,6 para 4,6, um aumento de mais de sete
                                    vezes. No Se Liga, o aumento foi
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    menor, mas ainda muito expressivo, de 0,6 para 3,6 livros por aluno. <br /> <br /> Além dos efeitos sobre a
                                    alfabetização e aumento da proficiência, a prática da leitura, potencializada pelo acesso à um acervo
                                    diversificado amplia o <strong>repertório cultural</strong>, contribuindo ainda mais para o{' '}
                                    <strong>desenvolvimento integral dessas crianças.</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Styled.CardWhite2>
                            <Image
                                width={'80%'}
                                src={fetchStorageFile('anexo_storage_files_11216086647568750580.png_2025-11-19-1763584531807.png')}
                                alt={`
                                    Conjunto de ícones de livros para comparar a média de livros lidos por estudante antes e depois da participação nos programas. No Acelera Brasil: o número de livros lidos aumentou de 0,6 para 4,6 livros por estudante, 
                                    representado por ícones de livros e seta indicando crescimento de '7 vezes mais'. 
                                    No Se Liga: o número de livros lidos aumentou de 0,6 para 3,6 livros por estudante, com seta indicando '6 vezes mais'.” 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </Styled.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Como parte do programa <strong>Fórmula da Vitória</strong>, estudantes que enfrentavam defasagens na
                                    trajetória escolar foram convidados a redescobrir a força da palavra e o prazer de aprender por meio da
                                    poesia. O resultado desse percurso é um livro que reúne poemas nascidos das salas de aula e, que serão
                                    distribuídos para as escolas do município. Ao todo serão <strong>impressos 2 mil exemplares.</strong> Mais do
                                    que um produto pedagógico, essa coletânea celebra o potencial de cada estudante e reafirma a escola como
                                    espaço de desenvolvimento integral, cultura e encantamento com o saber.
                                </p>
                                <Styled.CardWhite2>
                                    <Image
                                        width={'100%'}
                                        src={fetchStorageFile('anexo_storage_files_3672161274491583716.png_2025-11-19-1763584984129.png')}
                                        alt=""
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </Styled.CardWhite2>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Enquanto os estudantes do <strong>Acelera Brasil</strong>, participaram de atividades voltadas à valorização
                                    do patrimônio cultural local, vivências que culminaram na <strong>produção de um curta-metragem.</strong> O
                                    filme sistematiza os aprendizados construídos durante o percurso e revela olhares sensíveis sobre a história
                                    e a identidade da comunidade. Mais do que um registro audiovisual, o curta expressa o sentimento de
                                    pertencimento e o orgulho de ser parte de um território repleto de cultura, memória e significados.
                                </p>
                                <p style={{ marginTop: '40px' }}>
                                    As soluções implementadas pelo Instituto Ayrton Senna foram avaliadas de maneira bem positiva pela equipe
                                    central na Secretaria de Educação, com <strong>82% de satisfação média.</strong> O aspecto mais bem avaliado
                                    foi a <strong>adequação, relevância e qualidade das soluções educacionais (93%).</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={20} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.TitleYellow>HISTÓRIAS DE SUPERAÇÃO</StyledGlobal.TitleYellow>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '10px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    <strong>Jessylen</strong> tinha 9 anos quando ingressou na turma do Se Liga. Com dificuldades para ler e sem
                                    conhecer o alfabeto e saber escrever o próprio nome, sentia vergonha e se sentia triste e frustrada, como
                                    relata sua avó Edileuza. Com a utilização de práticas pedagógicas inovadoras na rede de ensino, notadamente
                                    aquelas relacionadas ao incentivo à leitura, Jessylen tem apresentado avanços significativos na
                                    alfabetização.
                                    <br />
                                    <br /> Sua avó comenta a mudança:
                                </p>
                                <Quote
                                    text={`Mudou tudo. Ela está
                                            mais feliz, contente
                                            e se desenvolvendo
                                            melhor. Já leva livro
                                            pra casa para ler.”
                                        `}
                                    styles={{ fontStyle: 'italic', marginTop: '20px' }}
                                />
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn isMaxWidth="300px">
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_5781891972392850622.png_2025-11-19-1763586477912.png')}
                                    alt="Jessylen"
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                    </StyledGlobal.ContentColumn>

                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '10px' }}
                        >
                            <StyledGlobal.ContentColumn isMaxWidth="300px">
                                <Image
                                    src={fetchStorageFile('anexo_storage_files_12984685780540161107.png_2025-11-19-1763587269740.png')}
                                    alt="Miquéias"
                                    preview={{
                                        style: {
                                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                        },
                                    }}
                                />
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    <strong>Miquéias</strong>, de 13 anos, apesar de ser considerado um ótimo aluno pelas professoras,
                                    apresentava dificuldade em expressar suas emoções por um baixo repertório de Língua Portuguesa. Em 2025,
                                    ingressou na turma do Fórmula da Vitória. Declarando uma experiência muito positiva de aprendizagem com as
                                    metodologias utilizadas pelo programa, o adolescente relata com entusiasmo as mudanças que observou na sua
                                    forma de falar e se expressar.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Quote
                            text={`Eu me sinto feliz, orgulhoso de ter adquirido
                                            uma nova habilidade. Eu estou sabendo as
                                            palavras corretas, aprendi novas palavras,
                                            palavras que eu não sabia muito, o sentido
                                            delas. Acho que vai me ajudar muito no futuro!”
                                        `}
                            styles={{ fontStyle: 'italic', marginTop: '20px' }}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <CardQRcodeVideosPlanoAnual styles={{ marginTop: '40px' }} />
            </PageTemplatePlanoAnual>
        </>
    );
};

export default PageThreeOnePlanoAnual;
